import { IUserAccountInterface } from '../../client/interfaces/client-company.interface';


export interface IApproval {
  id :number;
  approvableId :number;
  approvableType :string;
  status :string;
  createdAt :string;
  updatedAt :string;
  approvable ?:any;
  approvalUsers ?:IApprovalUser[];
}

export interface IApprovalRule {
  id :number;
  name :string;
  model :string;
  operator :string;
  condition :any;
  order :number;
  approvalUserTemplateId :number;
  createdAt :string;
  updatedAt :string;
  approvalUserTemplate ?:IApprovalUserTemplate;
  enableSingleApprover ?:boolean;
}

export interface IApprovalUser {
  id :number;
  approvalId :number;
  userId :number;
  status :string;
  createdAt :string;
  updatedAt :string;
  approvalRules ?:IApprovalRule[];
}

export interface IApprovalUserTemplateAssignment {
  id :number;
  approvalUserTemplateId :number;
  userId :number;
  createdAt :string;
  updatedAt :string;
  approvalUserTemplate ?:IApprovalUserTemplate;
  user ?:IUserAccountInterface;
}

export interface IApprovalUserTemplate {
  id :number;
  label :string;
  createdAt :string;
  updatedAt :string;
  approvalUserTemplateAssignments ?:IApprovalUserTemplateAssignment[];
}

export enum EApprovalModel {
  SUPPLIER_PURCHASE_ORDER = 'Supplier Purchase Order',
  SALES_ORDER = 'Sales Order',
}

export enum ELogicalOperators {
  AND = 'AND',
  OR = 'OR',
}

export enum EComparisonOperators {
  GREATER_THAN = '>',
  LESS_THAN = '<',
  GREATER_THAN_OR_EQUAL_TO = '>=',
  LESS_THAN_OR_EQUAL_TO = '<=',
  EQUAL_TO = '==',
  NOT_EQUAL_TO = '!=',
}

export enum EApprovalStatusValue {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PARTIAL = 'PARTIAL',
  PENDING = 'PENDING',
}

export enum EApprovalStatus {
  NONE = 'N/A',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  PARTIAL = 'Partial Approval',
  PENDING = 'Pending',
}
